var map = {
	"./01_executionReport.json": "pjpR",
	"./02_ account_update.json": "5y10"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "smlZ";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/account \.json$
// module id = smlZ
// module chunks = 3